'use client';
import BenefitItem from '../benefitIcons/BenefitItem';
import offsetBlockClass from '@/utils/offsetBlockClass';

export default function PDPCompanyUSP({ block, position }) {
  if (!block || !block.pdp_company_usp.reference) {
    console.error('block or block.company_usp is undefined');
    return null;
  }
  const { item, uid, show_offset_block_selector } =
    block.pdp_company_usp.reference[0];
  return (
    <section
      id={`${uid}_${position}`}
      data-name="pdp-company-usp"
      className={offsetBlockClass(show_offset_block_selector, 'not-last:mb-8')}
    >
      <ul className="grid grid-cols-3 gap-0">
        {item?.map((item, index) => (
          <li
            key={index}
            className={`flex flex-col items-center justify-center px-2 py-1 text-center`}
          >
            <BenefitItem
              index={index}
              icon={item.icon}
              modalIcon={item.icon}
              title={item.title}
              description={item.description}
              size={'small'}
              productModal={true}
              buyBox={true}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
